import { FC, SetStateAction } from 'react';
import All from './OnBoardingBody';
import { Body, MainModal } from './OnBoardingPopup.styles';

interface IOnBoardingPopupProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenCategory: SetStateAction<any>;
}

const OnBoardingPopup: FC<IOnBoardingPopupProps> = ({
  open,
  setOpen,
  setOpenCategory,
}) => {
  return (
    <div>
      <MainModal
        sx={{
          height: { xs: '90%', sm: 'max-content' },
          width: { xs: '90%', sm: 'max-content' },
          outline: 'none',
        }}
        open={open}
        onClose={() => {
          setOpen(false);
          setOpenCategory(true);
        }}
        className="scrollbar-hidden"
      >
        <Body>
          <All setOpen={setOpen} />
        </Body>
      </MainModal>
    </div>
  );
};

export default OnBoardingPopup;
